import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import ToggleButtons from '@atlassian/toggle-buttons';
import ToggleButtonsOld from './ui/toggle-buttons-old';

export default componentWithFG('visual-refresh', ToggleButtons, ToggleButtonsOld);
